var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-global-menu"},[_c('im-icon',{staticClass:"im-icon text-18",attrs:{"icon":_vm.menuIcon}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t(`model.${_vm.model.title}`)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }